module.exports = __webpack_public_path__ + "static/media/4-Spades.54f1db61.svg";